import type { FromModel } from "@/__main__/data-model.mjs";
import createModel, { Mapped, Optional } from "@/__main__/data-model.mjs";

const ProsModal = Mapped({
  key: String,
  value: {
    id: Number,
    name: String,
    fame: Number,
    region: String,
    slug: String,
    team_id: Optional(Number),
    portrait_image_url: Optional(String),
    profile_image_url: Optional(String),
    inserted_at: String,
    updated_at: String,
  },
});

export const ProPlayers = createModel(ProsModal);

export type ProPlayers = FromModel<typeof ProPlayers>;
